import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "taxInfoBlock small d-block" };
const _hoisted_2 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.taxText) + " ", 1),
        (_ctx.tax === 0)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_2, "1"))
            : _createCommentVNode("", true)
    ]));
}
